<template>
    <div>
        <span>Nombre: </span>
        <input
                type="text"
                id="cookie_name"
                name="cookie_name"
                placeholder="Nombre de la cookie"
                :value="computedName"
                @change="onChangeCookieName($event)"
        >&nbsp;
        <span>Valor: </span>
        <input
                type="text"
                id="cookie_value"
                name="cookie_value"
                placeholder="Valor de la cookie"
                :value="computedValue"
                @change="onChangeCookieValue($event)"
        >
    </div>
</template>

<script>
    export default {
        name: 'cookie-input',
        props: {
            selectedValue : {
                type: Object
            }
        },
        data () {
            return {
                cookieName : null,
                cookieValue : null
            };
        },
        computed: {
            computedName: function () {
                if (this.cookieName !== null) {
                    return this.cookieName;
                }
                if (this.selectedValue['name']) {
                    return this.selectedValue['name'];
                }
                return '';
            },
            computedValue: function () {
                if (this.cookieValue !== null) {
                    return this.cookieValue;
                }
                if (this.selectedValue['value']) {
                    return this.selectedValue['value'];
                }
                return '';
            }
        },
        methods: {
            onChangeCookieName: function(event) {
                this.cookieName = event.target.value;
                let eventData = {'name' : this.computedName, 'value' : this.computedValue};
                this.$emit('update', eventData);
            },
            onChangeCookieValue: function(event) {
                this.cookieValue = event.target.value;
                let eventData = {'name' : this.computedName, 'value' : this.computedValue};
                this.$emit('update', eventData);
            }
        }
    }
</script>